export enum STORE_SLICES {
  CHAT = "chat",
  AUTH = "auth",
}
